var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSend0116 = function SvgSend0116(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0fc46d62-845f-471a-86c0-a5ee7bbceedaa)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CC4E00",
    fillRule: "evenodd",
    d: "m12.89 4.053-5.111 5.11 1.555 4zM6.835 8.221l5.11-5.11-9.11 3.555zm6.93-7.238c.122-.036.367-.1.631-.011a1 1 0 0 1 .632.631c.088.264.024.51-.011.632-.039.133-.1.292-.163.45l-4.411 11.306c-.07.177-.137.35-.203.483-.057.115-.183.359-.445.495a1 1 0 0 1-.924 0c-.262-.137-.388-.381-.445-.496-.065-.133-.132-.306-.201-.484l-1.74-4.474-4.451-1.73-.023-.01c-.178-.07-.35-.136-.484-.202-.115-.056-.36-.183-.496-.445a1 1 0 0 1 0-.923c.136-.262.38-.389.495-.446a7 7 0 0 1 .483-.202l.024-.01 11.28-4.401c.16-.063.319-.125.452-.163",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "0fc46d62-845f-471a-86c0-a5ee7bbceedaa"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgSend0116;